import styled from 'styled-components';

export const ValidityText = styled.span`
  color: #52c41a;
  font-weight: 500;
`;
